import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../auth/AuthService';
import {environment} from '../../environments/environment';
import {IOffice} from '../Model/Office';


@Injectable({
  providedIn: 'root'
})
export class PayerService {

  constructor(private httpClient: HttpClient,
              private authService: AuthService,) {

  }

  getAllPayers(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}payer`, params);
  }

  addPayer(body: IOffice): Observable<any> {
    return this.authService.post(`${environment.patientService}payer`, body);
  }

  updatePayer(body: any, params?:any): Observable<any> {
    return this.authService.put(`${environment.patientService}payer`,body, params);
  }

  getPayerDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}payer`, params);
  }

  deletePayer(params?:any): Observable<any> {
    return this.authService.delete(`${environment.patientService}payer`, params);
  }
}
